import { Box, Button, Container, Header, SpaceBetween, Table } from '@cloudscape-design/components';
import React, { FC } from 'react';
import { useModuleTranslation } from '../../lang';
import { Batch } from '../../models/Batch';
import { Movement } from '../../pages/AgpOverview.logic';
import { AgpTableBaseProps } from './types';

type Props = AgpTableBaseProps & {
  movements: Movement[];
  batchMap: Record<string, Batch>;
};

const RecentMovementsTable: FC<Props> = ({
  movements,
  batchMap,
  headerActions,
  refresh,
  loading,
  loadingText,
  emptyText,
  testId,
}) => {
  const t = useModuleTranslation('Agp.RecentMovementsTable');
  const actions = React.Children.toArray(headerActions ?? []);
  if (refresh) {
    actions.push(<Button key="refresh" iconName="refresh" variant="icon" onClick={refresh} disabled={loading} />);
  }
  return (
    <Container data-testid={testId}>
      <Header
        variant="h2"
        actions={
          <SpaceBetween size="xs" direction="horizontal">
            {actions}
          </SpaceBetween>
        }
      >
        {t.header}
      </Header>

      <Table<Movement>
        trackBy={(m) => m.id}
        variant="borderless"
        stickyHeader
        loading={loading}
        loadingText={loadingText}
        columnDefinitions={[
          { header: t.date, cell: (m) => m.date.toLocaleString('en-UK') },
          {
            header: t.direction,
            cell: (m) =>
              m.direction === 'OUT' ? (
                <span style={{ color: 'red', fontWeight: 600 }}>{m.sold > 0 ? t.sold : t.out}</span>
              ) : m.direction === 'VOID' ? (
                <span style={{ color: 'purple', fontWeight: 600 }}>VOID</span>
              ) : (
                <span style={{ color: 'green', fontWeight: 600 }}>{t.in}</span>
              ),
          },
          { header: t.product, cell: (r) => r.slug.charAt(0).toUpperCase() + r.slug.slice(1) },
          { header: t.bottleSize, cell: (m) => m.bottleName },
          { header: t.amount, cell: (m) => (m.sold > 0 ? m.sold : m.amount) },
          { header: t.batchId, cell: (m) => <>{batchMap[m.batchId]?.batchId ?? '…'}</> },
          { header: t.uniqueId, cell: (m) => <Box variant="awsui-gen-ai-label">{m.batchId}</Box> },
          { header: t.note, cell: (m) => m.note ?? '' },
        ]}
        items={movements}
        empty={<Box padding="m">{emptyText ?? t.empty}</Box>}
      />
    </Container>
  );
};

export default RecentMovementsTable;
